// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import React from 'react'
import { Mutation, Query } from 'react-apollo'
import NewSelect from '../../../../../common/select/NewSelect'
import { i18n } from '../../../../index'
import { createFileLink, fetchAokFileLinks, fetchFileLinks } from '../../queries'
import { fetchLinkTags } from '../LinkTags/queries'
import css from './CreationDialog.css'

const updateCacheOnCreate =
  (companyId) =>
  (cache, { data: { createFileLink } }) => {
    const query = companyId ? fetchAokFileLinks : fetchFileLinks
    const variables = companyId
      ? {
          companyId: companyId,
        }
      : {}
    const fieldName = companyId ? 'aokFileLinks' : 'fileLinks'
    const data = cache.readQuery({
      query: query,
      variables: variables,
    })
    cache.writeQuery({
      query: query,
      variables,
      data: {
        [fieldName]: [...data[fieldName], createFileLink],
      },
    })
  }

class CreationDialog extends React.Component {
  constructor() {
    super()
    this.state = {
      fileName: '',
      href: '',
      selectedLinkTag: '',
    }
  }

  onCancel = () => {
    this.setState({
      fileName: '',
      href: '',
      selectedLinkTag: '',
    })
    this.props.close()
  }
  onSubmit = (e, onMutate) => {
    const { companyId } = this.props
    e.preventDefault()
    const { fileName, href, selectedLinkTag } = this.state
    onMutate({
      variables: {
        fileName,
        href,
        companyId,
        linkTagId: selectedLinkTag,
      },
      update: updateCacheOnCreate(companyId),
    })
    this.props.close()
    this.setState({
      fileName: '',
      href: '',
      selectedLinkTag: '',
    })
  }

  onLinkTagSelected = (value: string) => {
    this.setState({
      ...this.state,
      selectedLinkTag: value === '' ? null : value,
    })
  }

  render() {
    const { isOpen } = this.props
    const { fileName, href, selectedLinkTag } = this.state

    return (
      <Dialog open={isOpen} onBackdropClick={this.onCancel} disableEnforceFocus>
        <DialogTitle>{i18n.t('admin.guidelinesAndLinks.creationDialogTitle')}</DialogTitle>

        <DialogContent>
          <Query query={fetchLinkTags}>
            {({ data, loading }) => (
              <Mutation mutation={createFileLink}>
                {(onMutate) => (
                  <form onSubmit={(e) => this.onSubmit(e, onMutate)}>
                    <TextField
                      autoFocus
                      required
                      fullWidth
                      label={i18n.t('admin.guidelinesAndLinks.fileName')}
                      placeholder={i18n.t('admin.guidelinesAndLinks.fileNamePlaceholder')}
                      className={css.input}
                      value={fileName}
                      onChange={(e) =>
                        this.setState({
                          fileName: e.target.value,
                        })
                      }
                    />

                    <TextField
                      required
                      fullWidth
                      label={i18n.t('admin.guidelinesAndLinks.link')}
                      placeholder={i18n.t('admin.guidelinesAndLinks.linkPlaceholder')}
                      className={css.input}
                      value={href}
                      onChange={(e) =>
                        this.setState({
                          href: e.target.value,
                        })
                      }
                    />

                    <NewSelect
                      options={data?.linkTags?.map((linkTag) => ({ label: linkTag.name, value: linkTag.id })) ?? []}
                      value={selectedLinkTag ?? ''}
                      onChange={this.onLinkTagSelected}
                      label={i18n.t('admin.guidelinesAndLinks.selectTag')}
                    />

                    <DialogActions>
                      <Button type='button' onClick={this.onCancel}>
                        {i18n.t('buttons.cancel')}
                      </Button>
                      <Button type={'submit'} color={'primary'}>
                        {i18n.t('buttons.save')}
                      </Button>
                    </DialogActions>
                  </form>
                )}
              </Mutation>
            )}
          </Query>
        </DialogContent>
      </Dialog>
    )
  }
}

export default CreationDialog
